import { CheckCircle2 } from "lucide-react";

const TEAM_MEMBERS = [
  {
    name: "Dr. Vishal Salunkhe",
    role: "Inventor & CEO",
    image: "https://customer-assets.emergentagent.com/job_ominar-hub/artifacts/dda2jwrc_dr%20salunkhe.jpg",
    credentials: [
      "PhD in Biomedical Science (UCD, Ireland)",
      "Postdoctoral Scientist @ Sanquin Blood Bank, Amsterdam",
      "10+ years in biomedical research"
    ],
    color: "cyan"
  },
  {
    name: "Dr. Amar More",
    role: "Inventor & CTO",
    image: "https://customer-assets.emergentagent.com/job_1488b547-0470-4710-9082-0fb679cd81f3/artifacts/y0k6u65g_WhatsApp%20Image%202026-03-12%20at%2011.39.51.jpeg",
    credentials: [
      "PhD in Pharmacology and Toxicology (IVRI, India)",
      "Postdoctoral Scientist @ UTMB, Galveston, USA",
      "8 years in biomedical research"
    ],
    color: "indigo"
  }
];

const COLOR_CLASSES = {
  cyan: "from-cyan-500/20 to-cyan-600/10 border-cyan-500/30",
  indigo: "from-indigo-500/20 to-indigo-600/10 border-indigo-500/30",
  emerald: "from-emerald-500/20 to-emerald-600/10 border-emerald-500/30"
};

export const Team = () => (
  <section id="team" data-testid="team-section" className="relative py-24 md:py-32">
    <div className="absolute inset-0 bg-white" />
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,_rgba(99,102,241,0.08),transparent_70%)]" />

    <div className="relative max-w-7xl mx-auto px-6 md:px-12">
      <div className="text-center max-w-3xl mx-auto mb-16">
        <span className="text-cyan-600 text-sm font-mono uppercase tracking-widest">The Inventors</span>
        <h2 className="font-display text-3xl md:text-5xl font-bold text-slate-800 mt-4 mb-6">
          Meet The <span className="gradient-text">Inventors</span>
        </h2>
        <p className="text-slate-600 text-lg">
          World-class researchers dedicated to revolutionizing kidney health diagnostics
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-3xl mx-auto">
        {TEAM_MEMBERS.map((member) => (
          <div
            key={member.name}
            data-testid={`team-member-${member.name.toLowerCase().replace(/[^a-z0-9]/g, '-')}`}
            className={`group relative rounded-2xl bg-gradient-to-b ${COLOR_CLASSES[member.color]} border p-6 hover:scale-105 transition-all duration-300`}
          >
            <div className="w-24 h-24 mx-auto mb-6 rounded-full bg-slate-100 border-2 border-slate-300 overflow-hidden">
              <img
                src={member.image}
                alt={member.name}
                className="w-full h-full object-cover"
              />
            </div>

            <h3 className="font-display text-lg font-semibold text-slate-800 text-center mb-1">
              {member.name}
            </h3>
            <p className="text-cyan-600 text-sm text-center mb-4">{member.role}</p>

            <ul className="space-y-2">
              {member.credentials.map((cred) => (
                <li key={cred} className="flex items-start gap-2 text-slate-600 text-xs">
                  <CheckCircle2 className="w-3 h-3 text-emerald-600 flex-shrink-0 mt-0.5" />
                  <span>{cred}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  </section>
);
